import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css'
import Header from './components/layouts/Header2';
import Dashboard from "./components/layouts/Dashboard";
import PrivacyPolicy from "./components/views/Main/PrivacyPolicy";

// import Login from "./components/views/Auth/Login"
import Roles from "./components/views/Auth/Roles";
import Users from "./components/views/Auth/Users";
import PermissionSetup from "./components/views/Auth/PermissionSetup";
import UserForm from "./components/views/Auth/UserForm";
import ChangePasswordForm from "./components/views/Auth/ChangePasswordForm";
import UpdateUserForm from "./components/views/Auth/UpdateUserForm";
import RoleForm from "./components/views/Auth/RoleForm";
import UpdateRoleForm from "./components/views/Auth/UpdateRoleForm";
import UserActions from "./components/views/Auth/UserActions";

import Stations from "./components/views/Area/Stations";
import StationsForm from "./components/views/Area/StationForm";
import UpdateStationsForm from "./components/views/Area/UpdateStationForm";
import StationLocations from "./components/views/Area/StationLocations";

import Lines from "./components/views/Area/Lines";
import LinesForm from "./components/views/Area/LineForm";
import UpdateLineForm from "./components/views/Area/UpdateLineForm";
import LineLocations from "./components/views/Area/LineLocations";

import Villages from "./components/views/Area/Villages";
import VillagesForm from "./components/views/Area/VillagesForm";
import UpdateVillagesForm from "./components/views/Area/UpdateVillageForm";
import VillageLocations from "./components/views/Area/VillageLocations";

import Zones from "./components/views/Area/Zones";
import ZoneForm from "./components/views/Area/ZoneForm";
import UpdateZoneForm from "./components/views/Area/UpdateZoneForm";
import ZoneLocations from "./components/views/Area/ZoneLocations";


import LocationGroups from "./components/views/Area/LocationGroups";
import LocationGroupForm from "./components/views/Area/LocationGroupForm";
import UpdateLocationGroupForm from "./components/views/Area/UpdateLocationGroupForm";
import Locations from "./components/views/Area/Locations";
import ServerSideLocations from "./components/views/Area/ServerSideLocations";
import LocationForm from "./components/views/Area/LocationForm";
import LocationIOSummary from "./components/views/Area/LocationIOSummary";
import NewLocations from "./components/views/Area/NewLocations";
import ReconnectedLocations from "./components/views/Area/ReconnectedLocations";
import DisconnectedLocations from "./components/views/Area/DisconnectedLocations";
import ImportLocationForm from "./components/views/Area/ImportLocationForm";
import UpdateLocationForm from "./components/views/Area/UpdateLocationForm";
import DebitLocationForm from "./components/views/Area/DebitLocationForm";
import LocationBillingHistory from "./components/views/Area/LocationBillingHistory";
import QuickLocationHistory from "./components/views/Area/QuickLocationHistory";
import LocationMonthlyPaymentDetail from "./components/views/Area/LocationMonthlyPaymentDetail";
import LocationMessageHistory from "./components/views/Area/LocationMessageHistory";
import MessageLocationForm from "./components/views/Area/MessageLocationForm";
import LocationSuspensionHistory from "./components/views/Area/LocationSuspensionHistory";
import ReconnectLocationForm from "./components/views/Area/ReconnectLocationForm";
import DisconnectLocationForm from "./components/views/Area/DisconnectLocationForm";
import ConnectMeterForm from "./components/views/Area/ConnectMeter";

import CustomersForm from "./components/views/Main/CustomerForm";
import UpdateCustomerForm from "./components/views/Main/UpdateCustomerForm";

import EmployeeCategories from "./components/views/Main/EmployeeCategories";
import EmployeeCategoryForm from "./components/views/Main/EmployeeCategoryForm";
import UpdateEmployeeCategoryForm from "./components/views/Main/UpdateEmployeeCategory";

import Employees from "./components/views/Main/Employees";
import EmployeesForm from "./components/views/Main/EmployeeForm";
import UpdateEmployeesForm from "./components/views/Main/UpdateEmployeeForm";

import TodoCategories from "./components/views/Main/TodoCategories";
import TodoCategoryForm from "./components/views/Main/TodoCategoryForm";
import UpdateTodoCategoryForm from "./components/views/Main/UpdateTodoCategoryForm";

import Todos from "./components/views/Main/Todos";
import TodoForm from "./components/views/Main/TodoForm";
import UpdateTodoForm from "./components/views/Main/UpdateTodoForm";
import TechnicianTodos from "./components/views/Main/TechnicianTodos";

import MeterCategories from "./components/views/Measurement/MeterCategories";
import MeterCategoryForm from "./components/views/Measurement/MeterCategoryForm";
import UpdateMeterCategoryForm from "./components/views/Measurement/UpdateMeterCategoryForm";

import ServerSideMeters from "./components/views/Measurement/ServerSideMeters";
import Meters from "./components/views/Measurement/Meters";
import MeterForm from "./components/views/Measurement/MeterForm";
import MultiPartForm from "./components/views/Area/MultiPart";
import UpdateMeterForm from "./components/views/Measurement/UpdateMeterForm";

import Rates from "./components/views/Measurement/Rates";
import RateForm from "./components/views/Measurement/RateForm";
import UpdateRateForm from "./components/views/Measurement/UpdateRateForm";
import RateLocations from "./components/views/Measurement/RateLocations";

import Ranges from "./components/views/Measurement/Ranges";
import RangeForm from "./components/views/Measurement/RangeForm";
import UpdateRangeForm from "./components/views/Measurement/UpdateRangeForm";

import Billed from "./components/views/Billed/Billed";
import Invoice from "./components/views/Billed/Invoice";
import Receipt from "./components/views/Report/Receipt";
import ZeroReadingSummary from "./components/views/Billed/ZeroReadingSummary";
import ZeroReadingDetail from "./components/views/Billed/ZeroReadingDetail";
import BilledDetail from "./components/views/Billed/BilledDetail";
import UnBilled from "./components/views/UnBilled/UnBilled";
import UnBilledDetail from "./components/views/UnBilled/UnBilledDetail";
import BillForm from "./components/views/UnBilled/AddBillForm";
import FixedBillForm from "./components/views/UnBilled/AddBillFixedForm";
import UnPaid from "./components/views/UnPaid/UnPaid";
import LessPaidSummary from "./components/views/UnPaid/LessPaidSummary";
import LessPaidDetail from "./components/views/UnPaid/LessPaidDetail";
import UnPaidDetail from "./components/views/UnPaid/UnPaidDetail";
import XMonthsUnPaid from "./components/views/UnPaid/XMonthsUnPaid";
import XMonthsUnPaidDetail from "./components/views/UnPaid/XMonthsUnPaidDetail";
import SubPayment from "./components/views/Transaction/SubPayment";
import Payment from "./components/views/Transaction/Payment";
import PaymentAppointmentForm from "./components/views/Transaction/PaymentAppointmentForm";

import DailyCollectionSummary from "./components/views/Report/DailyCollectionSummary";
import DailyCollectionDetail from "./components/views/Report/DailyCollectionDetail";

import DailyReadingSummary from "./components/views/Report/DailyReadingSummary";
import DailyReadingDetail from "./components/views/Report/DailyReadingDetail";

import DailyAppointments from "./components/views/Report/DailyAppointments";

import MonthlyVoucherSummary from "./components/views/Report/MonthlyVoucherSummary";
import MonthlyVoucherDetails from "./components/views/Report/MonthlyVoucherDetails";
import UpdateVoucherForm from "./components/views/Report/UpdateVoucher";
import UpdateBookVouchersForm from "./components/views/Report/UpdateBookVouchers";
import MonthlyReportSummary from "./components/views/Report/MonthlyReportSummary";
import MotorMonthlyReportSummary from "./components/views/Measurement/MotorMonthlyReport";

import AccountPayable from "./components/views/Accounting/AccountPayableSummary";
import AccountPayableDetail from "./components/views/Accounting/AccountPayableDetails";
import CreditVendorForm from "./components/views/Accounting/CreditVendorForm";
import AddEmployeeCommissionForm from "./components/views/Accounting/AddEmployeeCommissionForm";
import DebitVendorForm from "./components/views/Accounting/DebitVendorForm";
import AccountReceivable from "./components/views/Accounting/AccountReceivableSummary";
import AccountReceivableDetail from "./components/views/Accounting/AccountReceivableDetail";
import LocationBalance from "./components/views/Accounting/LocationBalanceSummary";
import LocationBalanceDetail from "./components/views/Accounting/LocationBalanceDetail";
import ExpenseCategories from "./components/views/Accounting/ExpenseCategories";
import ExpenseCategoryForm from "./components/views/Accounting/ExpenseCategoryForm";
import UpdateExpenseCategoryForm from "./components/views/Accounting/UpdateExpenseCategoryForm";
import ExpenseSummary from "./components/views/Accounting/ExpensesSummary";
import ExpenseDetails from "./components/views/Accounting/ExpenseDetails";
import DailyExpenses from "./components/views/Accounting/DailyExpenses";
import ExpenseForm from "./components/views/Accounting/ExpenseForm";
import AccountAdjustmentForm from "./components/views/Accounting/AccountAdjustmentForm";
import Accounts from "./components/views/Accounting/Accounts";
import AccountForm from "./components/views/Accounting/AccountForm";
import UpdateAccountForm from "./components/views/Accounting/UpdateAccountForm";
import FundTransferForm from "./components/views/Accounting/FundTransferForm";
import CollectorTransferForm from "./components/views/Accounting/CollectorCashTransfer";
import CashBalance from "./components/views/Accounting/CashBalance";
import CashFlow from "./components/views/Accounting/CashFlows";
import CashBalanceDetail from "./components/views/Accounting/CashBalanceDetail";
import Vendors from "./components/views/Accounting/Vendors";
import VendorForm from "./components/views/Accounting/VendorForm";
import UpdateVendorForm from "./components/views/Accounting/UpdateVendorForm";
import CollectorAccounts from "./components/views/Accounting/CollectorAccounts";
import CollectorBalanceSummary from "./components/views/Accounting/CollectorBalanceSummary";
import CollectorBalanceDetail from "./components/views/Accounting/CollectorBalanceDetail";
import CollectorAccountForm from "./components/views/Accounting/CollectorAccountForm";
import UpdateCollectorAccountForm from "./components/views/Accounting/UpdateCollectorAccountForm";
import GeneratePayrolForm from "./components/views/Accounting/GeneratePayrollForm";
import GenerateBranchPayrolForm from "./components/views/Accounting/GenerateBranchPayrollForm";
import Payroll from "./components/views/Accounting/Payroll";
import BranchPayroll from "./components/views/Accounting/BranchPayrolls";
import SubPayPayroll from "./components/views/Accounting/SubPayPayrollForm";
import PayPayrollForm from "./components/views/Accounting/PayPayrollForm";
import PayBranchPayrollForm from "./components/views/Accounting/PayBranchPayrollForm";
import EmployeeMonthlyStatement from "./components/views/Main/EmployeeMonthlyStatement";
import VendorStatement from "./components/views/Accounting/VendorStatements";
import Motors from "./components/views/Measurement/Motors";
import MotorForm from "./components/views/Measurement/MotorForm";
import UpdateMotorForm from "./components/views/Measurement/UpdateMotorForm";
import MotorReport from "./components/views/Measurement/MotorReports";
import MotorReportForm from "./components/views/Measurement/MotorReportForm";
import UpdateMotorReportForm from "./components/views/Measurement/UpdateMotorReportForm";

import Groups from "./components/views/SMS/Groups";
import GroupForm from "./components/views/SMS/GroupForm";
import UpdateGroupForm from "./components/views/SMS/UpdateGroupForm";
import MessageCategories from "./components/views/SMS/MessageCategories";
import MessageCategoryForm from "./components/views/SMS/MessageCategoryForm";
import UpdateMessageCategoryForm from "./components/views/SMS/UpdateMessageCategoryForm";
import SendLocationMessageForm from "./components/views/Area/SendLocationMessageForm";
import SendUnpaidMessageForm from "./components/views/UnPaid/SendUnpaidMessageForm";
import XMonthsUnpaidMessageForm from "./components/views/UnPaid/XMonthsUnPaidMessageForm";
import MessageBalance from "./components/views/SMS/MessageBalane";
import MessageBalanceDetail from "./components/views/SMS/MessageBalanceDetail";
import Pricing from "./components/views/SMS/SmsPricing";
import AdjustSMSForm from "./components/views/SMS/AdjustMessageBalance";
import BuySmsForm from "./components/views/SMS/BuySmsForm";
import MessageDeliverySummary from "./components/views/SMS/MessageDeliverySummary";
import MessageDeliveryDetail from "./components/views/SMS/MessageDeliveryDetail";
import SendMessageForm from "./components/views/SMS/SendMessage";
import SignIn from "./components/views/Auth/SingIn";

import ComplaintCategories from "./components/views/Complaints/ComplaintCategories";
import ComplaintCategoryForm from "./components/views/Complaints/ComplaintCategoryForm";
import UpdateComplaintCategoryForm from "./components/views/Complaints/UpdateComplaintCategoryForm";
import Complaints from "./components/views/Complaints/Complaints";
import ComplaintForm from "./components/views/Complaints/ComplaintForm";
import ComplaintDetail from "./components/views/Complaints/ComplaintDetail";
import MyComplaints from "./components/views/Complaints/MyComplaints";

import ServerSideCustomers from "./components/views/Main/ServerSideCustomers";
import ServerSideBilled from "./components/views/Billed/ServerSideBilled";
import ServerSideUnBilled from "./components/views/UnBilled/ServerSideUnBilled";
import UpdateForm from "./components/views/UnBilled/UpdateUnBillForm";
import ServerSideUnPaid from "./components/views/UnPaid/ServerSideUnPaid";

import Companies from "./components/views/Administrator/Companies";
import CompanyForm from "./components/views/Administrator/CompanyForm";
import UpdateCompanyForm from "./components/views/Administrator/UpdateCompanyForm";
import Branches from "./components/views/Administrator/Branches";
import BranchForm from "./components/views/Administrator/BranchForm";
import UpdateBranchForm from "./components/views/Administrator/UpdateBranchForm";
import Menus from "./components/views/Administrator/Menus";
import MenuForm from "./components/views/Administrator/MenuForm";
import UpdateMenuForm from "./components/views/Administrator/UpdateMenuForm";
import BranchMessageBalance from "./components/views/SMS/BranchSMSBalance";
import ExampleComponent from "./components/views/Area/HandsonTable";

import { AuthProvider } from "./context/auth/AuthContext";

function App() {

  return (
    <Router>
      <>
      <AuthProvider>
        <div className="page">
          <Header/>
          <br/>   
        <div className="page-wrapper container-xl card">
          <br/>  
          <Routes>
          <Route exact path='/handson-table' element={<ExampleComponent/>}></Route>
          <Route exact path='/companies' element={<Companies/>}></Route>
          <Route exact path='/add-company' element={<CompanyForm/>}></Route>
          <Route exact path='/update-company' element={<UpdateCompanyForm/>}></Route>
          <Route exact path='/branches' element={<Branches/>}></Route>
          <Route exact path='/add-branch' element={<BranchForm/>}></Route>
          <Route exact path='/update-branch' element={<UpdateBranchForm/>}></Route>
          <Route exact path='/menus' element={<Menus/>}></Route>
          <Route exact path='/add-menu' element={<MenuForm/>}></Route>
          <Route exact path='/update-menu' element={<UpdateMenuForm/>}></Route>

          <Route exact path='/login' element={<SignIn/>}></Route>
          <Route exact path='/' element={<Dashboard/>}></Route>
          
          <Route exact path='/billed-serverside' element={<ServerSideBilled/>}></Route>
          <Route exact path='/un-billed-serverside' element={<ServerSideUnBilled/>}></Route>
          <Route exact path='/un-billed-update' element={<UpdateForm/>}></Route>
          <Route exact path='/un-paid-serverside' element={<ServerSideUnPaid/>}></Route>

          <Route exact path='/login' element={<SignIn/>}></Route>

            {/* SMS Routes */}
            <Route exact path='/groups' element={<Groups/>}></Route>
            <Route exact path='/add-group' element={<GroupForm/>}></Route>
            <Route exact path='/update-group' element={<UpdateGroupForm/>}></Route>
            <Route exact path='/message-categories' element={<MessageCategories/>}></Route>
            <Route exact path='/add-message-category' element={<MessageCategoryForm/>}></Route>
            <Route exact path='/update-message-category' element={<UpdateMessageCategoryForm/>}></Route>
            <Route exact path='/send-location-message' element={<SendLocationMessageForm/>}></Route>
            <Route exact path='/send-unpaid-message' element={<SendUnpaidMessageForm/>}></Route>
            <Route exact path='/send-x-months-unpaid-message' element={<XMonthsUnpaidMessageForm/>}></Route>
            <Route exact path='/branch-sms-balance' element={<BranchMessageBalance/>}></Route>
            <Route exact path='/sms-balance' element={<MessageBalance/>}></Route>
            <Route exact path='/sms-balance-detail' element={<MessageBalanceDetail/>}></Route>
            <Route exact path='/sms-pricing' element={<Pricing/>}></Route>
            <Route exact path='/sms-buy' element={<BuySmsForm/>}></Route>
            <Route exact path='/sms-adjust' element={<AdjustSMSForm/>}></Route>
            <Route exact path='/message-delivery-summary' element={<MessageDeliverySummary/>}></Route>
            <Route exact path='/message-delivery-detail' element={<MessageDeliveryDetail/>}></Route>
            <Route exact path='/send-custom-message' element={<SendMessageForm/>}></Route>

            {/* Motor & its reports Routes */}
            <Route exact path='/motors' element={<Motors/>}></Route>
            <Route exact path='/add-motor' element={<MotorForm/>}></Route>
            <Route exact path='/update-motor' element={<UpdateMotorForm/>}></Route>
            <Route exact path='/motor-daily-reports' element={<MotorReport/>}></Route>
            <Route exact path='/motor-monthly-report-summary' element={<MotorMonthlyReportSummary/>}></Route>
            <Route exact path='/add-motor-report' element={<MotorReportForm/>}></Route>
            <Route exact path='/update-motor-report' element={<UpdateMotorReportForm/>}></Route>

            {/* Accounting Routes */}
            <Route exact path='/vendors' element={<Vendors/>}></Route>
            <Route exact path='/add-vendor' element={<VendorForm/>}></Route>
            <Route exact path='/update-vendor' element={<UpdateVendorForm/>}></Route>
            <Route exact path='/add-employee-commission' element={<AddEmployeeCommissionForm/>}></Route>
            <Route exact path='/credit-vendor' element={<CreditVendorForm/>}></Route>
            <Route exact path='/debit-vendor' element={<DebitVendorForm/>}></Route>
            <Route exact path='/collector-accounts' element={<CollectorAccounts/>}></Route>
            <Route exact path='/collector-account-balance-summary' element={<CollectorBalanceSummary/>}></Route>
            <Route exact path='/collector-account-balance-detail' element={<CollectorBalanceDetail/>}></Route>
            <Route exact path='/add-collector-account' element={<CollectorAccountForm/>}></Route>
            <Route exact path='/update-collector-account' element={<UpdateCollectorAccountForm/>}></Route>
            <Route exact path='/expense-categories' element={<ExpenseCategories/>}></Route>
            <Route exact path='/add-expense-category' element={<ExpenseCategoryForm/>}></Route>
            <Route exact path='/update-expense-category' element={<UpdateExpenseCategoryForm/>}></Route>
            <Route exact path='/expenses' element={<ExpenseSummary/>}></Route>
            <Route exact path='/payroll' element={<Payroll/>}></Route>
            <Route exact path='/branch-payroll' element={<BranchPayroll/>}></Route>
            <Route exact path='/sub-pay-payroll' element={<SubPayPayroll/>}></Route>
            <Route exact path='/pay-payroll' element={<PayPayrollForm />}></Route>
            <Route exact path='/expense-detail' element={<ExpenseDetails/>}></Route>
            <Route exact path='/daily-expenses' element={<DailyExpenses/>}></Route>
            <Route exact path='/add-expense' element={<ExpenseForm/>}></Route>
            <Route exact path='/adjust' element={<AccountAdjustmentForm/>}></Route>
            <Route exact path='/generate-payroll' element={<GeneratePayrolForm/>}></Route>
            <Route exact path='/generate-branch-payroll' element={<GenerateBranchPayrolForm/>}></Route>
            <Route exact path='/pay-branch-payroll' element={<PayBranchPayrollForm/>}></Route>
            <Route exact path='/employee-monthly-statement' element={<EmployeeMonthlyStatement/>}></Route>
            <Route exact path='/vendor-statement' element={<VendorStatement/>}></Route>
            <Route exact path='/accounts' element={<Accounts/>}></Route>
            <Route exact path='/cash-balance' element={<CashBalance/>}></Route>
            <Route exact path='/cash-flow' element={<CashFlow/>}></Route>
            <Route exact path='/cash-balance-detail' element={<CashBalanceDetail/>}></Route>
            <Route exact path='/fund-transfer' element={<FundTransferForm/>}></Route>
            <Route exact path='/collector-cash-transfer' element={<CollectorTransferForm/>}></Route>
            <Route exact path='/add-account' element={<AccountForm/>}></Route>
            <Route exact path='/update-account' element={<UpdateAccountForm/>}></Route>
            <Route exact path='/account-payable' element={<AccountPayable/>}></Route>
            <Route exact path='/account-payable-detail' element={<AccountPayableDetail/>}></Route>
            <Route exact path='/account-receivable' element={<AccountReceivable/>}></Route>
            <Route exact path='/account-receivable-detail' element={<AccountReceivableDetail/>}></Route>
            <Route exact path='/location-balance' element={<LocationBalance/>}></Route>
            <Route exact path='/location-balance-detail' element={<LocationBalanceDetail/>}></Route>

            {/* Report Routes */}
            <Route exact path='/monthly-voucher-summary' element={<MonthlyVoucherSummary/>}></Route>
            <Route exact path='/monthly-voucher-detail' element={<MonthlyVoucherDetails/>}></Route>
            <Route exact path='/update-voucher' element={<UpdateVoucherForm/>}></Route>
            <Route exact path='/update-book-vouchers' element={<UpdateBookVouchersForm/>}></Route>
            <Route exact path='/monthly-report-summary' element={<MonthlyReportSummary/>}></Route>
            
            <Route exact path='/daily-collection-summary' element={<DailyCollectionSummary/>}></Route>
            <Route exact path='/daily-collection-detail' element={<DailyCollectionDetail/>}></Route>
            <Route exact path='/daily-reading-summary' element={<DailyReadingSummary/>}></Route>
            <Route exact path='/daily-reading-detail' element={<DailyReadingDetail/>}></Route>
            <Route exact path='/daily-appointments' element={<DailyAppointments/>}></Route>

            <Route exact path='/sub-payment' element={<SubPayment/>}></Route>
            <Route exact path='/payment' element={<Payment/>}></Route>
            <Route exact path='/add-payment-appointment' element={<PaymentAppointmentForm/>}></Route>

            <Route exact path='/' element={<Dashboard/>}></Route>
            
            {/* Auth Routes */}
            {/* <Route path='/login' element={<Login/>}></Route> */}
            <Route path='/permission-setup' element={<PermissionSetup/>}></Route>
            <Route path='/users' element={<Users/>}></Route>
            <Route path='/user-actions' element={<UserActions/>}></Route>
            <Route path='/roles' element={<Roles/>}></Route>
            <Route path='/add-role' element={<RoleForm/>}></Route>
            <Route path='/add-user' element={<UserForm/>}></Route>
            <Route path='/update-user' element={<UpdateUserForm/>}></Route>
            <Route path='/update-role' element={<UpdateRoleForm/>}></Route>
            <Route path='/change-password' element={<ChangePasswordForm/>}></Route>
            
            {/* Area Routes */}
            <Route path='/stations' element={<Stations/>}></Route>
            <Route path='/station-locations' element={<StationLocations/>}></Route>
            <Route path='/add-station' element={<StationsForm/>}></Route>
            <Route path='/update-station' element={<UpdateStationsForm/>}></Route>
            <Route path='/lines' element={<Lines/>}></Route>
            <Route path='/line-locations' element={<LineLocations/>}></Route>
            <Route path='/add-line' element={<LinesForm/>}></Route>
            <Route path='/update-line' element={<UpdateLineForm/>}></Route>
            <Route path='/villages' element={<Villages/>}></Route>
            <Route path='/village-locations' element={<VillageLocations/>}></Route>
            <Route path='/add-village' element={<VillagesForm/>}></Route>
            <Route path='/update-village' element={<UpdateVillagesForm/>}></Route>
            <Route path='/zones' element={<Zones/>}></Route>
            <Route path='/zone-locations' element={<ZoneLocations/>}></Route>
            <Route path='/add-zone' element={<ZoneForm/>}></Route>
            <Route path='/update-zone' element={<UpdateZoneForm/>}></Route>
            <Route path='/locations' element={<Locations/>}></Route>
            <Route path='/locations-serverside' element={<ServerSideLocations/>}></Route>
            <Route path='/location-groups' element={<LocationGroups/>}></Route>
            <Route path='/add-location-group' element={<LocationGroupForm/>}></Route>
            <Route path='/update-location-group' element={<UpdateLocationGroupForm/>}></Route>

            <Route path='/add-location' element={<LocationForm/>}></Route>
            <Route path='/import-location' element={<ImportLocationForm/>}></Route>
            <Route path='/update-location' element={<UpdateLocationForm/>}></Route>
            <Route path='/location-billing-history' element={<LocationBillingHistory/>}></Route>
            <Route path='/quick-location-history' element={<QuickLocationHistory/>}></Route>
            <Route path='/location-monthly-payment-detail' element={<LocationMonthlyPaymentDetail/>}></Route>
            <Route path='/location-message-history' element={<LocationMessageHistory/>}></Route>
            <Route path='/debit-location' element={<DebitLocationForm/>}></Route>
            <Route path='/send-single-message' element={<MessageLocationForm/>}></Route>
            <Route path='/location-io-summary' element={<LocationIOSummary/>}></Route>
            <Route path='/location-io-new' element={<NewLocations/>}></Route>
            <Route path='/location-io-reconnected' element={<ReconnectedLocations/>}></Route>
            <Route path='/location-io-disconnected' element={<DisconnectedLocations/>}></Route>
            <Route path='/location-suspension-history' element={<LocationSuspensionHistory/>}></Route>
            <Route path='/reconnect-location' element={<ReconnectLocationForm/>}></Route>
            <Route path='/disconnect-location' element={<DisconnectLocationForm/>}></Route>
            <Route path='/connect-meter' element={<ConnectMeterForm/>}></Route>

            <Route path='/todo-categories' element={<TodoCategories/>}></Route>
            <Route path='/add-todo-category' element={<TodoCategoryForm/>}></Route>
            <Route path='/update-todo-category' element={<UpdateTodoCategoryForm/>}></Route>
            <Route path='/todos' element={<Todos/>}></Route>
            <Route path='/add-todo' element={<TodoForm/>}></Route>
            <Route path='/update-todo' element={<UpdateTodoForm/>}></Route>
            <Route path='/technician-todos' element={<TechnicianTodos/>}></Route>

            {/* Main -> Customer Routes */}
            <Route exact path='/customers-serverside' element={<ServerSideCustomers/>}></Route>
            <Route path='/add-customer' element={<CustomersForm/>}></Route>
            <Route path='/update-customer' element={<UpdateCustomerForm/>}></Route>
            <Route path='/privacy' element={<PrivacyPolicy/>}></Route>

            {/* Main -> Employee Routes */}
            <Route path='/employees' element={<Employees/>}></Route>
            <Route path='/add-employee' element={<EmployeesForm/>}></Route>
            <Route path='/update-employee' element={<UpdateEmployeesForm/>}></Route>

            {/* Main -> EmployeeCategory Routes */}
            <Route path='/employee-categories' element={<EmployeeCategories/>}></Route>
            <Route path='/add-employee-category' element={<EmployeeCategoryForm/>}></Route>
            <Route path='/update-employee-category' element={<UpdateEmployeeCategoryForm/>}></Route>

            {/* Measurements -> MeterCategory Routes */}
            <Route path='/meter-categories' element={<MeterCategories/>}></Route>
            <Route path='/add-meter-category' element={<MeterCategoryForm/>}></Route>
            <Route path='/update-meter-category' element={<UpdateMeterCategoryForm/>}></Route>

            {/* Measurements -> Meter Routes */}
            <Route path='/meters-serverside' element={<ServerSideMeters/>}></Route>
            <Route path='/meters' element={<Meters/>}></Route>
            <Route path='/add-meter' element={<MeterForm/>}></Route>
            <Route path='/update-meter' element={<UpdateMeterForm/>}></Route>
            <Route path='/multi-part' element={<MultiPartForm/>}></Route>

            {/* Measurements -> Rate Routes */}
            <Route path='/rates' element={<Rates/>}></Route>
            <Route path='/add-rate' element={<RateForm/>}></Route>
            <Route path='/update-rate' element={<UpdateRateForm/>}></Route>
            <Route path='/rate-locations' element={<RateLocations/>}></Route>

            {/* Measurements -> Range Routes */}
            <Route path='/ranges' element={<Ranges/>}></Route>
            <Route path='/add-range' element={<RangeForm/>}></Route>
            <Route path='/update-range' element={<UpdateRangeForm/>}></Route>

            {/* Billed -> Billed Routes */}
            <Route path='/billed' element={<Billed/>}></Route>
            <Route path='/add-bill' element={<BillForm/>}></Route>
            <Route path='/add-fixed-bill' element={<FixedBillForm/>}></Route>
            <Route path='/billed-collector' element={<BilledDetail/>}></Route>
            <Route path='/billed-village' element={<BilledDetail/>}></Route>
            <Route path='/billed-zone' element={<BilledDetail/>}></Route>
            <Route path='/billed-station' element={<BilledDetail/>}></Route>
            <Route path='/billed-line' element={<BilledDetail/>}></Route>
            <Route path='/billed-rate' element={<BilledDetail/>}></Route>
            <Route path='/billed-none' element={<BilledDetail/>}></Route>
            <Route path='/zero-reading-summary' element={<ZeroReadingSummary/>}></Route>
            <Route path='/zero-reading-detail' element={<ZeroReadingDetail/>}></Route>
            <Route path='/invoice' element={<Invoice/>}></Route>
            <Route path='/receipt' element={<Receipt/>}></Route>
            <Route path='/un-billed' element={<UnBilled/>}></Route>
            <Route path='/un-billed-collector' element={<UnBilledDetail/>}></Route>
            <Route path='/un-billed-zone' element={<UnBilledDetail/>}></Route>
            <Route path='/un-billed-village' element={<UnBilledDetail/>}></Route>
            <Route path='/un-billed-station' element={<UnBilledDetail/>}></Route>
            <Route path='/un-billed-line' element={<UnBilledDetail/>}></Route>
            <Route path='/un-billed-rate' element={<UnBilledDetail/>}></Route>
            <Route path='/un-billed-none' element={<UnBilledDetail/>}></Route>
            
            <Route path='/un-paid' element={<UnPaid/>}></Route>
            <Route path='/less-paid-summary' element={<LessPaidSummary/>}></Route>
            <Route path='/less-paid-detail' element={<LessPaidDetail/>}></Route>
            <Route path='/x-months-un-paid' element={<XMonthsUnPaid/>}></Route>
            <Route path='/x-months-un-paid-detail' element={<XMonthsUnPaidDetail/>}></Route>
            <Route path='/un-paid-collector' element={<UnPaidDetail/>}></Route>
            <Route path='/un-paid-zone' element={<UnPaidDetail/>}></Route>
            <Route path='/un-paid-village' element={<UnPaidDetail/>}></Route>
            <Route path='/un-paid-station' element={<UnPaidDetail/>}></Route>
            <Route path='/un-paid-line' element={<UnPaidDetail/>}></Route>
            <Route path='/un-paid-rate' element={<UnPaidDetail/>}></Route>
            <Route path='/un-paid-none' element={<UnPaidDetail/>}></Route>

            {/* Complaints Routes */}
            <Route path='/complaint-categories' element={<ComplaintCategories/>}></Route>
            <Route path='/add-complaint-category' element={<ComplaintCategoryForm/>}></Route>
            <Route path='/update-complaint-category' element={<UpdateComplaintCategoryForm/>}></Route>
            <Route path='/complaints' element={<Complaints/>}></Route>
            <Route path='/add-complaint' element={<ComplaintForm/>}></Route>
            <Route path='/complaint-detail' element={<ComplaintDetail/>}></Route>
            <Route path='/my-complaints' element={<MyComplaints/>}></Route>

          </Routes>
          </div>


          </div>
        <ToastContainer/>
      </AuthProvider>
      </>
    </Router>
  );
}

export default App;
